import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Permissions } from "./permissions.enum";
import { Role } from "./team.service";
import { User } from "./user.model";
import { UserService } from "./user.service";

type PermissionMap = Partial<Record<Role, RoleAllowedPermission>>;

type RoleAllowedPermission = {
    [key in Permissions]?: true;
};

@Injectable({
    providedIn: "root",
})
export class PermissionsService {
    private permissionsMap: PermissionMap = {
        editor: {
            [Permissions.AddPageAdditions]: true,
            [Permissions.AddSlides]: true,
            [Permissions.AssignmentDetails]: true,
            [Permissions.AssignmentMeta]: true,
            [Permissions.CloneAssignment]: true,
            [Permissions.CopyAssignment]: true,
            [Permissions.DeleteAssignment]: true,
            [Permissions.DeleteSlides]: true,
            [Permissions.EditAbbreviation]: true,
            [Permissions.EditAffiliatesState]: true,
            [Permissions.EditArticleTaxonomies]: true,
            [Permissions.EditDueDate]: true,
            [Permissions.EditGlobalBannedWords]: true,
            [Permissions.EditGlobalTaxonomies]: true,
            [Permissions.EditGlobalTechniques]: true,
            [Permissions.EditIntroWordCount]: true,
            [Permissions.EditMetaDescription]: true,
            [Permissions.EditMetaImage]: true,
            [Permissions.EditMetaTitle]: true,
            [Permissions.EditMSNFields]: true,
            [Permissions.EditN2SState]: true,
            [Permissions.EditNarrativeState]: true,
            [Permissions.EditOutroWordCount]: true,
            [Permissions.EditPriority]: true,
            [Permissions.EditQuizType]: true,
            [Permissions.EditReferences]: true,
            [Permissions.EditSlideCount]: true,
            [Permissions.EditSlideWordCount]: true,
            [Permissions.EditTags]: true,
            [Permissions.EditTargetPublishDate]: true,
            [Permissions.EditLastReviewDate]: true,
            [Permissions.EditSiteVerticals]: true,
            [Permissions.HideOnPage]: true,
            [Permissions.PublishAssignment]: true,
            [Permissions.UpdateAssignment]: true,
            [Permissions.UseAiPrompt]: true,
            [Permissions.UseSlideAi]: true,
        },
        writer: {
            [Permissions.AssignmentMeta]: true,
            [Permissions.AddPageAdditions]: true,
            [Permissions.AddSlides]: true,
            [Permissions.DeleteSlides]: true,
            [Permissions.EditMetaDescription]: true,
            [Permissions.EditMetaImage]: true,
            [Permissions.EditMetaTitle]: true,
            [Permissions.EditMSNFields]: true,
            [Permissions.EditReferences]: true,
            [Permissions.SubmitAssignment]: true,
            [Permissions.UseAiPrompt]: true,
            [Permissions.UseSlideAi]: true,
        },
        dmc: {
            [Permissions.AssignmentDetails]: true,
            [Permissions.AssignmentMeta]: true,
            [Permissions.CloneAssignment]: true,
            [Permissions.CopyAssignment]: true,
            [Permissions.UpdateAssignment]: true,
        },
        contributor: {
            [Permissions.SubmitAssignment]: true,
        }
    };

    constructor(private userService: UserService) {}
    private getCurrentUserRole() {
        const user: User = this.userService.currentUser;

        const role = user.getRole();
        if (role == "") return "writer" as Role;
        return role as Role;
    }

    userHasPermission(permission: Permissions): boolean {
        const role = this.getCurrentUserRole();

        if (role === "administrator") return true;

        const permissionMap = this.permissionsMap[role];
        if (!permissionMap) return false;

        return permissionMap[permission] === true;
    }
}
